import * as React from 'react'
import * as PropTypes from 'prop-types'
import * as PapaParse from 'papaparse'
import Encoding from 'encoding-japanese'

export interface IFileInfo {
  name: string
  size: number
  type: string
}

export interface CSVReaderProps {
  accept?: string
  cssClass?: string
  cssInputClass?: string
  fileEncoding?: string
  inputId?: string
  inputStyle?: object
  label?: string | React.ReactNode
  onError?: (error: Error) => void
  onFileLoaded: (data: Array<any>, fileInfo: IFileInfo) => any
  parserOptions?: PapaParse.ParseConfig
  disabled?: boolean
}

export const CSVReader: React.FC<CSVReaderProps> = ({
  accept = '.csv, text/csv',
  cssClass = 'csv-reader-input',
  cssInputClass = 'csv-input',
  fileEncoding = 'UTF-8',
  inputId = 'react-csv-reader-input',
  inputStyle = {},
  label,
  onError,
  onFileLoaded,
  parserOptions = {} as PapaParse.ParseConfig,
  disabled = false,
}) => {
  const handleChangeFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    const reader: FileReader = new FileReader()
    const files: FileList = e.target.files!
    if (files.length > 0) {
      const fileInfo: IFileInfo = {
        name: files[0].name,
        size: files[0].size,
        type: files[0].type,
      }

      reader.onload = (_event: Event) => {
        // // 8ビット符号なし整数値配列と見なす
        // @ts-ignore
        const array = new Uint8Array(reader.result)
        reader.readAsText(files[0], Encoding.detect(array))
        reader.onload = (_event: Event) => {
          const csvData = PapaParse.parse(
            reader.result as string,
            Object.assign(parserOptions, {
              error: onError,
              encoding: fileEncoding,
            }),
          )
          onFileLoaded(csvData.data ? csvData.data : [], fileInfo)
        }
      }
      reader.readAsArrayBuffer(files[0])
    }
  }

  return (
    <div className={cssClass}>
      {label && (
        <label htmlFor={inputId} style={{ cursor: 'pointer', padding: '10px 0' }}>
          {label}
        </label>
      )}
      <input
        className={cssInputClass}
        type="file"
        id={inputId}
        style={inputStyle}
        accept={accept}
        onChange={e => handleChangeFile(e)}
        disabled={disabled}
      />
    </div>
  )
}

CSVReader.propTypes = {
  accept: PropTypes.string,
  cssClass: PropTypes.string,
  cssInputClass: PropTypes.string,
  fileEncoding: PropTypes.string,
  inputId: PropTypes.string,
  inputStyle: PropTypes.object,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  onError: PropTypes.func,
  onFileLoaded: PropTypes.func.isRequired,
  parserOptions: PropTypes.object,
  disabled: PropTypes.bool,
}
